import { toTablePagination } from '@sparklayer-io/spark-dash-ui/utils/pagination';
import { Card, EmptyState } from '@ui/themed';
import { t } from 'i18next';
import { useMemo, useState } from 'react';
import { SearchInput } from '../../../components/search-input';
import { SparkSuspense } from '../../../components/spark-suspense';
import { useSearchCompanies } from '../hooks/use-companies';
import type { CompanyListQuery } from '../types/api';
import { CompaniesTable } from './companies-table';

export function CompaniesSearchTable(): JSX.Element {
  const [searchValue, setSearchValue] = useState('');

  const searchQuery = useMemo<CompanyListQuery>(
    () => (searchValue ? { search_term: searchValue } : {}),
    [searchValue],
  );

  const query = useSearchCompanies(searchQuery);
  const companies = query.data ?? [];

  const isSearching = searchValue.length > 0;
  const showEmptyState = companies.length === 0 && !query.isLoading;
  const emptyStateKey = isSearching ? 'no_results_state' : 'empty_state';

  return (
    <SparkSuspense
      onReload={query.refetch}
      isError={query.isError}
      errorMessage={t('features:companies.pages.companies_list_page.load_error')}
      isLoading={query.isLoading}
    >
      {(isSearching || companies.length > 0) && (
        <SearchInput
          onSearchChange={setSearchValue}
          placeholder={t('features:companies.pages.companies_list_page.search_placeholder')}
        />
      )}
      {showEmptyState ? (
        <Card>
          <EmptyState
            title={t(`features:companies.pages.companies_list_page.${emptyStateKey}.title`)}
            subtitle={t(`features:companies.pages.companies_list_page.${emptyStateKey}.subtitle`)}
            imageType="customerGroup"
          />
        </Card>
      ) : (
        <CompaniesTable
          companies={companies}
          pagination={toTablePagination(query, companies.length)}
        />
      )}
    </SparkSuspense>
  );
}
